import { render, staticRenderFns } from "./ModalRedeem.vue?vue&type=template&id=2399628f&scoped=true"
import script from "./ModalRedeem.vue?vue&type=script&lang=js"
export * from "./ModalRedeem.vue?vue&type=script&lang=js"
import style0 from "./ModalRedeem.vue?vue&type=style&index=0&id=2399628f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399628f",
  null
  
)

export default component.exports